import {
  formatUnits,
  parseUnits,
  readContract,
  writeContractAndWait,
} from "../viem";
import MafiaHealthAbi from "../../abis/MafiaHealth.json";
import config from "../../config/config";

const contractAddress = config.healthAddress;
const abi = MafiaHealthAbi;

export const balanceOfHealth = async (
  address: string,
  signMsg: string,
  signature: string
) => {
  const balance = await readContract<string>({
    address: contractAddress,
    abi,
    functionName: "balanceOf",
    args: [address, JSON.stringify(signMsg), signature],
  });
  const decimal = await readContract<string>({
    address: contractAddress,
    abi,
    functionName: "decimals",
  });
  return formatUnits(balance, decimal);
};

export const getHealthAllowance = async (from: string, to: string) => {
  const decimals = Number(
    await readContract<string>({
      address: contractAddress,
      abi,
      functionName: "decimals",
    })
  );
  const data = await readContract<string>({
    address: contractAddress,
    abi,
    functionName: "allowances",
    args: [from, to],
  });
  return Number(formatUnits(data, decimals.toString()));
};